
import { FormatByteArrayToGuidString, base64ToUint8Array, base64toGuid } from "../helpers"
import DataTable from "./DataTable"

const sizeofInt16 = 2
const sizeofInt32 = 4
const sizeofInt64 = 8
const sizeofSingle = 4
const sizeofDouble = 8

const NativeFieldType = {
    BOOL:  0,
    BYTE: 1,
    SHORT: 2,
    INT: 3,
    LONG: 4,
    FLOAT: 5,
    DOUBLE: 6,
    GUID: 7,
    STRING: 8,
    DATE: 9,
    BYNARY: 10
}

class NativeField {

    constructor(name, type){

        this.name = name
        this.type = type
        this.value = null

    }

}

export default class NativeTable{

    constructor(b64data){

        this.data = []
        this.currentOffset = 0;
        this.size = 0;
        this.dataOffset = 0;

        this.fieldsList = []
        this.fieldsDictionary = {}

        console.log('raw data')
        console.log(b64data)

        let data = base64ToUint8Array(b64data)

        console.log(data)

        this.init(data, 0, data.length);

    }


    init(data, offset, size){
        this.data = data
        this.currentOffset = offset
        this.size = size

        this.readFieldDescriptions()

        this.dataOffset = this.currentOffset;

        this.moveFirst();
    }


    readFieldDescriptions(){
        console.log('readFieldDescriptions')

        var size = this.readInt32(this.currentOffset)
        this.currentOffset += sizeofInt32

        while (this.currentOffset < sizeofInt32 + size){

            let type = this.data[this.currentOffset]
            this.currentOffset++

            let len = this.readInt32(this.currentOffset)
            this.currentOffset += sizeofInt32;

            let name = this.readUtfString(this.currentOffset, len)
            this.currentOffset += len

            //console.log('readFieldDescriptions '+ name + ' ' + type)
            const field = new NativeField(name, type)

            this.fieldsList.push(field)
            this.fieldsDictionary[name] = field

        }

        console.log('fieldsList');
        console.log(this.fieldsList);

    }



    moveFirst(){
        //console.log('moveFirst')
        this.currentOffset = this.dataOffset;
    }

    readNext(){
        //console.log('readNext ' + this.currentOffset)
        if (!this.EOF()) this.readRow();
    }


    EOF(){
        //console.log('EOF ' + this.currentOffset + ' >= ' + this.size )
        return this.currentOffset >= this.size;
    }


    readRow(){

        //console.log('readRow')

        this.fieldsList.forEach(field => {

            const flags = this.readByte(this.currentOffset)
            //console.log('flags')
            //console.log(flags)
            this.currentOffset++

            const isNull = (flags & 1) == 0

            if (isNull){
                field.value = null
            }else{

                //console.log('field.name ' + field.name + ' field.type '+field.type)

                switch (field.type){
                    case NativeFieldType.BOOL:
                        field.value = this.readByte(this.currentOffset) != 0;
                        this.currentOffset++
                        break

                    case NativeFieldType.BYTE:
                        field.value = this.readByte(this.currentOffset)
                        this.currentOffset++;
                        break

                    case NativeFieldType.SHORT:
                        field.value =  this.readInt16(this.currentOffset)
                        this.currentOffset += sizeofInt16
                        break

                    case NativeFieldType.INT:
                        field.value =  this.readInt32(this.currentOffset)
                        this.currentOffset += sizeofInt32
                        break

                    case NativeFieldType.LONG:
                        field.value =  this.readInt64(this.currentOffset)
                        this.currentOffset += sizeofInt64
                        break

                    case NativeFieldType.FLOAT:
                        field.value = this.readSingle(this.currentOffset)
                        this.currentOffset += sizeofSingle
                        break

                    case NativeFieldType.DOUBLE:
                        field.value = this.readDouble(this.currentOffset)
                        this.currentOffset += sizeofDouble
                        break

                    case NativeFieldType.GUID:
                        field.value =this.readGUID(this.currentOffset)
                        this.currentOffset += 16;
                        break

                    case NativeFieldType.STRING:
                        //console.log('read string')
                        //console.log('this.currentOffset '+ this.currentOffset)
                        const len = this.readInt32(this.currentOffset)
                        //console.log('str len '+ len)
                        this.currentOffset += sizeofInt32;
                        field.value = this.readUtfString(this.currentOffset, len) 
                        this.currentOffset += len
                        break

                    case NativeFieldType.DATE:
                        const val = this.readInt64(this.currentOffset)
                        field.value = val
                        //Utils.ConvertJavaMiliSecondsToUTCDateTime(val);
                        this.currentOffset += sizeofDouble;
                        break

                }

                //console.log('readfield '+field.name)
                //console.log(field.value)

            }

        })

        //console.log('this.fieldsList')
        //.log(this.fieldsList)

    }


    toDataTable(){

        const dataTable = new DataTable


        this.fieldsList.forEach( field => {
            dataTable.addColumn(field.name, this.typeName(field.type))
        })

        this.moveFirst()

        let i = 0
        while (!this.EOF()){
            //console.log(i)
            this.readNext()

            const row = {}

            this.fieldsList.forEach(field => row[field.name] = field.value ? field.value : null);

            dataTable.addRow(row)
            i++
        }


        return dataTable
    }


    typeName(type){

        switch (type){
            case NativeFieldType.BOOL: return 'bool'
            case NativeFieldType.BYTE: return 'byte'
            case NativeFieldType.SHORT: return 'short'
            case NativeFieldType.INT: return 'int'
            case NativeFieldType.LONG: return 'long'
            case NativeFieldType.FLOAT: return 'float'
            case NativeFieldType.DOUBLE: return 'double'
            case NativeFieldType.GUID: return 'guid'
            case NativeFieldType.STRING: return 'string'
            case NativeFieldType.DATE: return 'datetime'
        }

        return null
    }


    readByte(offset){
        return this.data[offset]
    }

    readInt(array){
        let value = 0
        for (var i = 0; i < array.length; i++) {
            value = (value << 8) | array[i];
        }
        return value
    }

    readUInt(array) {
        var value = 0;
        for (var i = 0; i < array.length; i++) {
            value += array[i] * Math.pow(256, i);
            //console.log(i + ' ' + array[i] + ' ' + value)
        }
        return value;
    }
    

    readInt16(offset){

        var u16bytes = this.data.slice(offset, offset + sizeofInt16 )//   u8.buffer.slice(-4); // last four bytes as a new `ArrayBuffer`
        //console.log('readInt16 u16bytes')
        //console.log(u16bytes)

        const uint = this.readUInt(u16bytes) 
        //var uint = new Int16Array(u16bytes)[0];
        
        //console.log('uint16')
        //console.log(uint)

        return uint
    }

    readInt32(offset){

        //console.log('readInt32 '+ offset)

        var u32bytes = this.data.slice(offset, offset + sizeofInt32 )//   u8.buffer.slice(-4); // last four bytes as a new `ArrayBuffer`
        //console.log('readInt32 u32bytes')
        //console.log(u32bytes)
        if(!u32bytes.length){
            debugger
        }

        const uint = this.readUInt(u32bytes) 

        //var uint = new Int32Array(u32bytes)[0];
        //console.log('uint32')
        //console.log(uint)

        return uint
    }

    readInt64(offset){

        //console.log('readInt64')

        /*
        var u32bytes = this.data.slice(offset, offset + sizeofInt32 )//   u8.buffer.slice(-4); // last four bytes as a new `ArrayBuffer`
        console.log('readInt32 u32bytes')
        console.log(u32bytes)
        var uint = new Int32Array(u32bytes)[0];
        console.log('uint32')
        console.log(uint)

        var u32bytes = this.data.slice(offset + sizeofInt32, offset + 2*sizeofInt32 )//   u8.buffer.slice(-4); // last four bytes as a new `ArrayBuffer`
        console.log('readInt32 u32bytes')
        console.log(u32bytes)
        var uint2 = new Int32Array(u32bytes)[0];
        console.log('uint32_2')
        console.log(uint2)
        */

        const u64bytes = this.data.slice(offset, offset + sizeofInt64 )

        
        //console.log('u64bytes')
        //console.log(u64bytes)

        return this.readUInt(u64bytes)


        //return parseInt((u64bytes).toString(), 10)

        //return uint + uint2 * Math.pow(2, 32)

        //return uint
    }

    readSingle(offset) {
        var bytes32 = this.data.slice(offset, offset + sizeofSingle )
        //console.log('readSingle bytes32')
        //console.log(bytes32)

        const buffer = new ArrayBuffer(sizeofSingle)
        const view = new DataView(buffer, 0 , sizeofSingle) // для ClearScript нужен конструктор со всеми параметрами
        for (let i = 0; i < bytes32.length; i++) {
            view.setUint8(i, bytes32[i])
        }

        //console.log('view')
        //console.log(view.buffer)
        
        let float32 = view.getFloat32(0, true)
        //console.log('float32')
        //console.log(float32)
        return float32;
    }

    readDouble(offset) {
        var bytes64 = this.data.slice(offset, offset + sizeofDouble )
        //console.log('readDouble bytes64')
        //console.log(bytes64)

        const buffer = new ArrayBuffer(sizeofDouble)
        const view = new DataView(buffer, 0 , sizeofDouble) // для ClearScript нужен конструктор со всеми параметрами
        for (let i = 0; i < bytes64.length; i++) {
            view.setUint8(i, bytes64[i])
        }
        let float64 = view.getFloat64(0, true)
        //console.log('float64')
        //console.log(float64)
        return float64;
    }

    readGUID(offset){
        let bytes = this.data.slice(offset, offset + 16 )
        return new FormatByteArrayToGuidString(bytes).toString()
    }

    /*
    bin2String(array) {
        var result = "";
        for (var i = 0; i < array.length; i++) {
            result += String.fromCharCode(parseInt(array[i], 2));
        }
        return result;
    }
    */

    readUtfString(offset, length){
        let bytes = this.data.slice(offset, this.currentOffset + length )
        //let string = this.bin2String(bytes)
        //return string
        //let str = new TextDecoder().decode(bytes); 
        //return str

        const decoder = new TextDecoder('utf-16');
        return decoder.decode(bytes);
    }

}